import { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    try {
      const response = await axios.post('https://whats-app.360websitedemo.com/api/register', {
        email,
        password,
      });
      setMessage(response.data.message);
      setEmail('');
      setPassword('');
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
      setMessage('');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4 sm:p-6 lg:p-8">
      <div className="w-full max-w-lg sm:max-w-2xl lg:max-w-4xl flex flex-col lg:flex-row bg-white shadow-xl rounded-xl overflow-hidden">
        {/* Left Section: WhatsApp Sender Info */}
        <div className="w-full lg:w-1/2 bg-green-600 text-white p-6 sm:p-8 flex flex-col justify-center">
          <h1 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">WhatsApp Sender</h1>
          <p className="text-sm sm:text-base mb-4 sm:mb-6">Create your account to start sending messages</p>
          <div className="space-y-2 sm:space-y-3">
            <p className="text-green-100 text-sm sm:text-base flex items-center">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Secure and instant messaging
            </p>
            <p className="text-green-100 text-sm sm:text-base flex items-center">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Easy account setup
            </p>
          </div>
        </div>

        {/* Right Section: Sign-up Form */}
        <div className="w-full lg:w-1/2 p-6 sm:p-8">
          <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 text-gray-800">Sign up to your account</h2>
          <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">Enter Email and password to create your account</p>
          {error && <p className="text-red-500 mb-4 text-sm sm:text-base">{error}</p>}
          {message && <p className="text-green-600 mb-4 text-sm sm:text-base">{message}</p>}
          <div className="space-y-4 sm:space-y-5">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-1">Email address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 sm:p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                placeholder="you@example.com"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 sm:p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                placeholder="••••••••"
                required
              />
            </div>
            <button
              type="button"
              onClick={handleSubmit}
              className="w-full bg-blue-600 text-white p-3 sm:p-4 rounded-lg hover:bg-blue-700 transition duration-200 font-medium"
            >
              Sign up
            </button>
          </div>
          <p className="mt-4 sm:mt-6 text-center text-gray-600 text-sm">
            Already have an account?{' '}
            <Link to="/" className="text-blue-600 hover:underline">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Register;